export default class ApolloClientException extends Error {
  constructor(message) {
    super(message);
    this.name = 'ApolloClientException';
  }
}



// WEBPACK FOOTER //
// ./src/exceptions/ApolloClientException.js